import React from 'react'
import underConst from "../../assets/const.png"

const Register = () => {
 return (
  <div>
   <img style={{width:"60%",margin: "4rem 0"}} src={underConst} alt="" />
  </div>
 )
}

export default Register